/**
 * !!! 注意：key的值要配置成 link的最后一级路径名。并查询下是否重复
 * 比如
 * {
 *  link: '/operating/curriculum',
      key: 'curriculum',
 *
 * }
 */
export default [
  {
    title: '首页',
    link: '/dashboard',
    key: 'dashboard',
    icon: '',
    children: [],
  },
  {
    title: '上课课表',
    key: 'operatingCurriculum',
    children: [
      {
        title: '上课课表',
        link: '/operating/curriculum',
        key: 'curriculum',
        icon: '',
        children: [],
      },
      {
        title: '教练课表',
        key: 'classCalendar',
        link: '/classCalendar',
        icon: '',
        children: [],
      },
    ],
  },
  {
    title: '运营管理',
    key: 'operating',
    icon: '',
    children: [
      {
        title: '订单管理',
        link: '/operating/order',
        key: 'order',
        icon: '',
        children: [],
      },
      {
        title: 'API外部订单',
        link: '/operating/outorder',
        key: 'outorder',
        icon: '',
        children: [],
      },
      {
        title: '客户管理',
        link: '/user/index',
        key: 'index',
        icon: '',
        children: [],
      },
      {
        title: '员工白名单',
        link: '/operating/whitelist',
        key: 'whitelist',
        icon: '',
        children: [],
      },
      {
        title: '作业点评',
        link: '/operating/classScore',
        key: 'classScore',
        icon: '',
        children: [],
      },
      {
        title: '线索用户管理',
        link: '/potentialUser',
        key: 'potentialUser',
        icon: '',
        children: [],
      },
      {
        title: '关联多人',
        link: '/operating/family',
        key: 'family',
        icon: '',
        children: [],
      },
      {
        title: '服务跟进',
        link: '/operating/followup',
        key: 'followup',
        icon: '',
        children: [],
      },
      {
        title: '分配管理',
        link: '/operating/distribution',
        key: 'distribution',
        icon: '',
        children: [],
      },
      {
        title: '未完成首课',
        link: '/operating/notBegin',
        key: 'notBegin',
        icon: '',
        children: [],
      },
      {
        title: '首课流失',
        link: '/operating/firstLoss',
        key: 'firstLoss',
        icon: '',
        children: [],
      },
      {
        title: '即将到期',
        link: '/operating/ExpiringSoon',
        key: 'ExpiringSoon',
        icon: '',
        children: [],
      },
      {
        title: '点评调度',
        link: '/operating/scoreSchedule',
        key: 'scoreSchedule',
        icon: '',
        children: [],
      },
      {
        title: '个人商家',
        link: '/operating/merchant',
        key: 'merchant',
        icon: '',
        children: [],
      },
      {
        title: '续费签约管理',
        link: '/operating/renewal',
        key: 'renewal',
        icon: '',
        children: [],
      },
      {
        title: '带参公众号',
        link: '/operating/customerAccount',
        key: 'customerAccount',
        icon: '',
        children: [],
      },
      {
        title: '优惠活动',
        link: '/operating/promotionActivity',
        key: 'promotionActivity',
        icon: '',
        children: [],
      },
      {
        title: '奖励活动',
        link: '/operating/rewardActivity',
        key: 'rewardActivity',
        icon: '',
        children: [],
      },
      {
        title: '薪资发放记录',
        link: '/operating/salaryRecords',
        key: 'salaryRecords',
        icon: '',
        children: [],
      },
      {
        title: '公域商品同步',
        link: '/operating/thirdGoodsSync',
        key: 'thirdGoodsSync',
        icon: '',
        children: [],
      },
      {
        title: '外部商品',
        link: '/operating/external-product',
        key: 'external-product',
        icon: '',
        children: [],
      },
      {
        title: '线下门店物料管理',
        link: '/operating/offlineMaterial',
        key: 'offlineMaterial',
        icon: '',
        children: [],
      },
      {
        title: 'LITTA智慧屏',
        link: '/ptdevice',
        key: 'ptdevice',
        icon: '',
        children: [],
      },
      {
        title: '保证金管理',
        link: '/operating/bondManage',
        key: 'bondManage',
        icon: '',
        children: [],
      },
      {
        title: '风控审核',
        link: '/operating/riskAudit',
        key: 'riskAudit',
        icon: '',
        children: [],
      },
      {
        title: '用户分布',
        link: '/user/distribute',
        key: 'userDistribute',
        icon: '',
        children: [],
      },
      {
        title: '用户变化识别',
        link: '/user/changes',
        key: 'userChanges',
        icon: '',
        children: [],
      },
    ],
  },
  {
    title: '商家管理',
    key: 'merchantManage',
    icon: '',
    children: [
      {
        title: '商家管理',
        link: '/merchant/manage',
        key: 'manage',
        icon: '',
        children: [],
      },
      {
        title: '商家等级',
        link: '/merchant/level',
        key: 'level',
        icon: '',
        children: [],
      },
      {
        title: '商家对账单',
        link: '/merchant/billPeriod',
        key: 'billPeriod',
        icon: '',
        children: [],
      },
      {
        title: '商家日数据统计',
        link: '/merchant/statisticsDay',
        key: 'statisticsDay',
        icon: '',
        children: [],
      },
      {
        title: '商家教练数据统计',
        link: '/merchant/statisticsMonth',
        key: 'statisticsMonth',
        icon: '',
        children: [],
      },
      {
        title: '教练绩效',
        link: '/merchant/performance',
        key: 'performance',
        icon: '',
        children: [],
      },
      {
        title: '合伙人管理',
        link: '/merchant/copartner',
        key: 'copartner',
        icon: '',
        children: [],
      },
      {
        title: '数据统计',
        link: '/merchant/statisticsChart',
        key: 'statisticsChart',
        icon: '',
        children: [],
      },
      {
        title: '合伙人结算',
        link: '/merchant/partnerSalary',
        key: 'partnerSalary',
        icon: '',
        children: [],
      },
      {
        title: '流量分配管理',
        link: '/merchant/traffictAllocationManage',
        key: 'traffictAllocationManage',
        icon: '',
        children: [],
      },
      {
        title: '商家分布',
        link: '/merchant/distribute',
        key: 'merchantDistribute',
        icon: '',
        children: [],
      },
    ],
  },
  {
    title: '雅典娜',
    key: 'athena',
    icon: '',
    children: [
      {
        title: '商家档案',
        link: '/athena/merchantProfile',
        key: 'merchantProfile',
        icon: '',
        children: [
          {
            title: '商家档案',
            link: '/athena/merchantProfile/detail',
            key: 'profileDetail',
            icon: '',
            children: [],
          },
        ],
      },
      {
        title: '资源包管理',
        link: '/athena/packManagement',
        key: 'packManagement',
        icon: '',
        children: [],
      },
      {
        title: '社区管理',
        link: '/athena/communityManagement',
        key: 'communityManagement',
        icon: '',
        children: [],
      },
      {
        title: '主动PUSH',
        link: '/athena/pushManagement',
        key: 'pushManagement',
        icon: '',
        children: [],
      },
      {
        title: '公告管理',
        link: '/athena/noticeManagement',
        key: 'noticeManagement',
        icon: '',
        children: [],
      },
      {
        title: '看得见投稿',
        link: '/athena/visibleSubmission',
        key: 'visibleSubmission',
        icon: '',
        children: [],
      },
    ],
  },
  {
    title: '营销推广',
    key: 'promotion1',
    icon: '',
    children: [
      {
        title: 'DM推广页',
        link: '/promotion',
        key: 'promotion',
        icon: '',
        children: [],
      },
      {
        title: '留咨页',
        link: '/promotion/consult',
        key: 'consult',
        icon: '',
        children: [],
      },
      {
        title: '兑换码',
        link: '/market/cdkey',
        key: 'cdkey',
        icon: '',
        children: [],
      },
      {
        title: '调度规则',
        link: '/operating/scheduling',
        key: 'scheduling',
        icon: '',
        children: [],
      },
      {
        title: '渠道配置',
        link: '/promotion/channel-config',
        key: 'channel-config',
        icon: '',
        children: [],
      },
      {
        title: '会员商品',
        link: '/operating/vip-goods',
        key: 'vip-goods',
        icon: '',
        children: [],
      },
      {
        title: '套餐商品',
        link: '/operating/package-goods',
        key: 'package-goods',
        icon: '',
        children: [],
      },
      {
        title: '实物商品',
        link: '/operating/physical-goods',
        key: 'physical-goods',
        icon: '',
        children: [],
      },
      {
        title: '分销管理',
        link: '/promotion/distributionManagement',
        key: 'distributionManagement',
        icon: '',
        children: [],
      },
    ],
  },
  {
    title: '触达中心',
    key: 'message',
    icon: '',
    children: [
      {
        title: 'API直充中心',
        link: '/message/recharge',
        key: 'recharge',
        icon: '',
        children: [],
      },
      {
        title: '消息模板',
        link: '/message/template',
        key: 'template',
        icon: '',
        children: [],
      },
      {
        title: '深度链接配置',
        link: '/message/deeplink',
        key: 'deeplink',
        icon: '',
        children: [],
      },
      {
        title: '触达记录',
        link: '/message/aiTel',
        key: 'aiTel',
        icon: '',
        children: [],
      },
      {
        title: '拉群规则',
        link: '/operating/group-rules',
        key: 'group-rules',
        icon: '',
        children: [],
      },
      {
        title: 'SOP触达',
        link: '/message/sopTouch',
        key: 'sopTouch',
        icon: '',
        children: [],
      },
      {
        title: 'RPA机器人',
        link: '/message/rpaRobot',
        key: 'rpaRobot',
        icon: '',
        children: [],
      },
      {
        title: 'H5链接配置',
        link: '/message/h5Config',
        key: 'h5Config',
        icon: '',
        children: [],
      },
      {
        title: '私域调度记录',
        link: '/message/privateDomain',
        key: 'privateDomain',
        icon: '',
        children: [],
      },
      {
        title: '关键词回复',
        link: '/message/keywordReply',
        key: 'keywordReply',
        icon: '',
        children: [],
      },
      {
        title: '关键词记录',
        link: '/message/keywordHistory',
        key: 'keywordHistory',
        icon: '',
        children: [],
      },
      {
        title: '标签配置',
        link: '/message/wxTagConfig',
        key: 'wxTagConfig',
        icon: '',
        children: [],
      },
      {
        title: 'APP配置',
        link: '/message/appSetting',
        key: 'appSetting',
        icon: '',
        children: [],
      },
      {
        title: '公众号菜单配置',
        link: '/message/officialAccountConfig',
        key: 'officialAccountConfig',
        icon: '',
        children: [],
      },
      {
        title: '触达黑名单',
        link: '/message/rpaBlacklist',
        key: 'rpaBlacklist',
        icon: '',
        children: [],
      },
      {
        title: '教练任务',
        link: '/message/coachTask',
        key: 'coachTask',
        icon: '',
        children: [],
      },
      {
        title: 'Prompt配置',
        link: '/message/prompt',
        key: 'prompt',
        icon: '',
        children: [],
      },
      {
        title: '消息触达',
        link: '/message/messageRecord',
        key: 'messageRecord',
        icon: '',
        children: [],
      },
      {
        title: '阿里消息',
        link: '/message/aliSms',
        key: 'aliSms',
        icon: '',
        children: [],
      },
      {
        title: '阿里消息',
        link: '/message/aliSmsHistory',
        key: 'aliSmsHistory',
        icon: '',
        children: [],
      },
      {
        title: '群RPA管理',
        link: '/message/groupRpaManagement',
        key: 'groupRpaManagement',
        icon: '',
        children: [],
      },
      {
        title: 'AI自动生成SOP',
        link: '/message/generateSopWithAI',
        key: 'generateSopWithAI',
        icon: '',
        children: [],
      },
      {
        title: 'RPA路由监控',
        link: '/message/rpaRoute',
        key: 'rpaRoute', // key 必须是链接最后一级路径名
        icon: '',
        children: [],
      },
    ],
  },
  {
    title: '动作库',
    key: 'action',
    icon: '',
    children: [
      {
        title: '易动',
        link: '/action/list',
        key: 'list',
        icon: '',
        children: [],
      },
      {
        title: '自定义动作',
        link: '/action/customAction',
        key: 'customAction',
        icon: '',
        children: [],
      },
      {
        title: '用户动作视频',
        link: '/action/user',
        key: 'user',
        icon: '',
        children: [],
      },
      {
        title: '体态禁用库',
        link: '/ActionForbidModel',
        key: 'ActionForbidModel',
        icon: '',
        children: [],
      },
      {
        title: '自编课程',
        link: '/action/selfWrittenCourses',
        key: 'selfWrittenCourses',
        icon: '',
        children: [],
      },
      {
        title: '用户计划',
        link: '/action/exclusivePlan',
        key: 'exclusivePlan',
        icon: '',
        children: [],
      },
      {
        title: '特色课程',
        link: '/action/featureCourse',
        key: 'featureCourse',
        icon: '',
      },
      {
        title: '专属计划',
        link: '/action/exclusiveProgram',
        key: 'exclusiveProgram',
        icon: '',
        children: [],
      },
    ],
  },
  {
    title: '媒资管理',
    key: 'mediaManagement',
    icon: '',
    children: [
      {
        title: '营销位配置',
        link: '/mediaManagement/marketingConfig',
        key: 'marketingConfig',
        icon: '',
        children: [],
      },
      {
        title: '首页内容配置',
        link: '/mediaManagement/firstPageConfig',
        key: 'firstPageConfig',
        icon: '',
        children: [],
      },
      {
        title: '栏目管理',
        link: '/mediaManagement/columnManagement',
        key: 'columnManagement',
        icon: '',
        children: [],
      },
      {
        title: '专题配置',
        link: '/mediaManagement/projectManagement',
        key: 'projectManagement',
        icon: '',
        children: [],
      },
      {
        title: '品类管理',
        link: '/mediaManagement/categoryManagement',
        key: 'categoryManagement',
        icon: '',
        children: [],
      },
      {
        title: '内容管理',
        link: '/mediaManagement/contentManagement/list',
        key: 'contentManagement',
        icon: '',
        children: [],
      },
      {
        title: '知识库管理',
        link: '/mediaManagement/knowledgeBase',
        key: 'knowledgeBase',
        icon: '',
        children: [],
      },
      {
        title: '视频管理',
        link: '/mediaManagement/videoManagement',
        key: 'videoManagement',
        icon: '',
        children: [],
      },
      {
        title: '分发渠道',
        link: '/mediaManagement/channelManagement',
        key: 'channelManagement',
        icon: '',
        children: [],
      },
      {
        title: '打卡海报管理',
        link: '/mediaManagement/punchPosterManagement',
        key: 'punchPosterManagement',
        icon: '',
        children: [],
      },
      {
        title: '功能介绍配置',
        link: '/mediaManagement/introConfig',
        key: 'introConfig',
        icon: '',
        children: [],
      },
      {
        title: '培训学院',
        link: '/mediaManagement/trainingCollege',
        key: 'trainingCollege',
        icon: '',
        children: [],
      },
    ],
  },
  {
    title: '教练管理',
    key: 'coachManage',
    icon: '',
    children: [
      {
        title: '上课教练',
        link: '/coachonline',
        key: 'coachonline',
        icon: '',
      },
      {
        title: '假期休假',
        link: '/leave',
        key: 'leave',
        icon: '',
      },
      {
        title: '授课统计',
        link: '/coachManage/classStatistics',
        key: 'classStatistics',
        icon: '',
      },
      {
        title: '教练薪资结算',
        link: '/operating/coachSalary',
        key: 'coachSalary',
        icon: '',
        children: [],
      },
      {
        title: '续费率',
        link: '/coachManage/renewalRate',
        key: 'renewalRate',
        icon: '',
      },
    ],
  },
  {
    title: '计划模板管理',
    key: 'plan',
    // link: '/classCalendar',
    icon: '',
    children: [
      {
        title: '计划阶段管理',
        link: '/plan/period',
        key: 'period',
        icon: '',
      },
      {
        title: '语音管理',
        link: '/plan/voice',
        key: 'voice',
        icon: '',
      },
      {
        title: '动作配置管理',
        link: '/technical/actionConfig',
        key: 'actionConfig',
        icon: '',
        children: [],
      },
      {
        title: '运动能力配置',
        link: '/technical/capabilityConfig',
        key: 'capabilityConfig',
        icon: '',
        children: [],
      },
      {
        title: '会员运动能力账户',
        link: '/technical/capabilityAccount',
        key: 'capabilityAccount',
        icon: '',
        children: [],
      },
      {
        title: '会员训练情况',
        link: '/technical/memberTrainingWorkspace',
        key: 'memberTrainingWorkspace',
        icon: '',
        children: [],
      },
      {
        title: '动作分析放开管理',
        link: '/technical/powerMoveWhitelist',
        key: 'powerMoveWhitelist',
        icon: '',
        children: [],
      },
      {
        title: '动作客观观察',
        link: '/technical/powerMoveEvaluation',
        key: 'powerMoveEvaluation',
        icon: '',
        children: [],
      },
      {
        title: '课程客观观察',
        link: '/technical/powerMoveCourseEvaluation',
        key: 'powerMoveCourseEvaluation',
        icon: '',
        children: [],
      },
    ],
  },
  {
    title: '薛定谔的猫',
    key: 'technical',
    icon: '',
    children: [
      {
        title: '信令',
        link: '/technical/signal',
        key: 'signal',
        icon: '',
        children: [],
      },
      {
        title: '监课',
        link: '/technical/patrol',
        key: 'patrol',
        icon: '',
        children: [],
      },
      {
        title: '课程事件',
        link: '/technical/roomDetail',
        key: 'roomDetail',
        icon: '',
        children: [],
      },
      {
        title: '课程用户降级',
        link: '/technical/degradationUser',
        key: 'degradationUser',
        icon: '',
        children: [],
      },
      {
        title: '降级管理',
        link: '/technical/degradationManager',
        key: 'degradationManager',
        icon: '',
        children: [],
      },
      {
        title: '设备性能查询',
        link: '/technical/devicePerformance',
        key: 'devicePerformance',
        icon: '',
        children: [],
      },
      {
        title: 'Xplan VK 管理',
        link: '/technical/xplanVkManage',
        key: 'xplanVkManage',
        icon: '',
        children: [],
      },
      {
        title: 'gptConfig',
        link: '/technical/gptConfig',
        key: 'gptConfig',
        icon: '',
        children: [],
      },
      {
        title: 'UNI版本管理',
        link: '/technical/uniPackageManager',
        key: 'uniPackageManager',
        icon: '',
        children: [],
      },
      {
        title: 'H5版本管理',
        link: '/technical/h5PackageManager',
        key: 'h5PackageManager',
        icon: '',
        children: [],
      },
      {
        title: 'IOS审核开关',
        link: '/technical/iosAuditSwitch',
        key: 'iosAuditSwitch',
        icon: '',
        children: [],
      },
      {
        title: '上传资源',
        link: '/technical/uploadResources',
        key: 'uploadResources',
        icon: '',
        children: [],
      },
      {
        title: '安卓审核开关',
        link: '/technical/androidAuditSwitch',
        key: 'androidAuditSwitch',
        icon: '',
        children: [],
      },
      {
        title: '标准课程灰度用户',
        link: '/technical/standardCourseGray',
        key: 'standardCourseGray',
        icon: '',
        children: [],
      },
      {
        title: 'SDK客户端管理',
        link: '/technical/sdkClient',
        key: 'sdkClient',
        icon: '',
        children: [],
      },
      {
        title: '事件埋点',
        link: '/technical/eventTracking',
        key: 'eventTracking',
        icon: '',
        children: [],
      },
      {
        title: '器械库',
        link: '/technical/equipmentLibrary',
        key: 'equipmentLibrary',
        icon: '',
        children: [],
      },
      {
        title: '店铺器械',
        link: '/technical/equipmentLibrary/storeEquipment',
        key: 'storeEquipment',
        icon: '',
        children: [],
      },
      {
        title: '商品商家修改',
        link: '/operating/goodsMerchantBind',
        key: 'goodsMerchantBind',
        icon: '',
        children: [],
      },
      {
        title: '诊断记录',
        link: '/technical/actionDiagnosis',
        key: 'actionDiagnosis',
        icon: '',
        children: [],
      },
      {
        title: '门店校准观测',
        link: '/technical/storeCalibration',
        key: 'storeCalibration',
        icon: '',
        children: [],
      },
      {
        title: 'LPAAS 发布',
        link: '/technical/lpaasPublish',
        key: 'lpaasPublish',
        icon: '',
        children: [],
      },
    ],
  },
  {
    title: '看板',
    key: 'chart',
    icon: '',
    children: [
      {
        title: '多维数据看板',
        link: '/chart/multiDimensionBoard',
        key: 'multiDimensionBoard',
        icon: '',
        children: [],
      },
      {
        title: '用户数据看板',
        link: '/chart/vipBoard',
        key: 'vipBoard',
        icon: '',
        children: [],
      },
      {
        title: '收入及订单数据',
        link: '/chart/orderBoard',
        key: 'orderBoard',
        icon: '',
        children: [],
      },
      {
        title: '指标看板',
        link: '/chart/targetBoard',
        key: 'targetBoard',
        icon: '',
        children: [],
      },
      {
        title: '经营看板',
        link: '/chart/businessBoard',
        key: 'businessBoard',
        icon: '',
        children: [],
      },
      {
        title: 'XPlan',
        link: '/chart/xplan',
        key: 'xplan',
        icon: '',
        children: [],
      },
      {
        title: '质量数据',
        link: '/chart/qualityData',
        key: 'qualityData',
        icon: '',
        children: [],
      },
      {
        title: '挑战赛仪表盘',
        link: '/chart/challengeRound',
        key: 'challengeRound',
        icon: '',
        children: [],
      },
      {
        title: '作业点评看版',
        link: '/chart/homeworkBoard',
        key: 'homeworkBoard',
        icon: '',
        children: [],
      },
      {
        title: '本地录制',
        link: '/chart/localRecord',
        key: 'localRecord',
        icon: '',
        children: [],
      },
      {
        title: '私教会员数据',
        link: '/chart/privateVipBoard',
        key: 'privateVipBoard',
        icon: '',
        children: [],
      },
      {
        title: '商家数据看板',
        link: '/chart/merchantDataDashboard',
        key: 'merchantDataDashboard',
        icon: '',
        children: [],
      },
      {
        title: '用户数据看板',
        link: '/chart/userDataDashboard',
        key: 'userDataDashboard',
        icon: '',
        children: [],
      },
      {
        title: '平台数据看板',
        link: '/chart/platformDataDashboard',
        key: 'platformDataDashboard',
        icon: '',
        children: [],
      },
      {
        title: '活力Go地图看板',
        link: '/vitalityGo/storeMap',
        key: 'storeMap',
        icon: '',
        children: [],
      },
    ],
  },
  {
    title: '系统配置',
    key: 'systemConfig',
    icon: '',
    children: [
      {
        title: '员工通讯录',
        link: '/systemConfig/addressBook',
        key: 'addressBook',
        icon: '',
        children: [],
      },
    ],
  },
  {
    title: '菜单权限',
    key: 'authorityConfig',
    icon: '',
    children: [
      {
        title: '菜单配置',
        link: '/authorityConfig/menuConfig',
        key: 'menuConfig',
        icon: '',
        children: [],
      },
      {
        title: '角色权限',
        link: '/authorityConfig/role',
        key: 'role',
        icon: '',
        children: [],
      },
      {
        title: '员工通讯录',
        link: '/authorityConfig/roleSetting',
        key: 'roleSetting',
        icon: '',
        children: [],
      },
      {
        title: '操作日志',
        link: '/authorityConfig/operationLog',
        key: 'operationLog',
        icon: '',
        children: [],
      },
    ],
  },
  {
    title: 'AI作业管理',
    key: 'aiWorkManager',
    icon: '',
    children: [
      {
        title: '动作管理',
        link: '/aiWorkManager/actionManager',
        key: 'actionManager',
        icon: '',
        children: [],
      },
      {
        title: '公式配置',
        link: '/aiWorkManager/formulaManager',
        key: 'formulaManager',
        icon: '',
        children: [],
      },
      {
        title: '动作分析结果',
        link: '/aiWorkManager/actionAnalysisResult',
        key: 'actionAnalysisResult',
        icon: '',
        children: [],
      },
      // {
      //   title: '模型标注',
      //   link: '/aiWorkManager/modelMark',
      //   key: 'modelMark',
      //   icon: '',
      //   children: [],
      // },
    ],
  },
  {
    title: '结算',
    key: 'settlement',
    icon: '',
    children: [
      {
        title: '账本管理',
        link: '/settlement/aliAccountManage',
        key: 'aliAccountManage',
        icon: '',
        children: [],
      },
      {
        title: '安全发结算',
        link: '/settlement/aliSettlementManage',
        key: 'aliSettlementManage',
        icon: '',
        children: [],
      },
      {
        title: '薪资结算管理',
        link: '/settlement/merchantSettlement',
        key: 'merchantSettlement',
        icon: '',
        children: [],
      },
    ],
  },
  {
    title: '优加运动处方',
    key: 'prescriptionGroup',
    icon: '',
    children: [
      {
        title: '处方计划库',
        link: '/prescription/planLibrary',
        key: 'planLibrary',
        icon: '',
        children: [],
      },
      {
        title: '匹配规则',
        link: '/prescription/rule',
        key: 'rule',
        icon: '',
        children: [],
      },
    ],
  },
  {
    title: '第三方',
    key: 'thirdpartyGroup',
    icon: '',
    children: [
      {
        title: '授权测试',
        link: '/thirdparty',
        key: 'thirdparty',
        icon: '',
        children: [],
      },
    ],
  },
];
